import {
  FETCH_AUDITTRAIL_REQUEST,
    FETCH_AUDITTRAIL_SUCCESS,
    FETCH_AUDITTRAIL_FAILURE,
  } from "./AuditTrailTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchAuditTrailRequest = () => {
    return {
      type: FETCH_AUDITTRAIL_REQUEST,
    };
  };
  
  export const fetchAuditTrailSuccess = (auditTrailList) => {
    return {
      type: FETCH_AUDITTRAIL_SUCCESS,
      payload: auditTrailList,
    };
  };
  
  export const fetchAuditTrailFailure = (error) => {
    return {
      type: FETCH_AUDITTRAIL_FAILURE,
      payload: error,
    };
  };
  

  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchAuditTrailListing = (searchKey, sortBy, page, activity_id) => {
    //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "user/audittrail/fetch?search_key=" + searchKey + "&sort_by=" + sortBy + "&page=" + page;
    
    //If activity is selected then add param
    if(parseInt(activity_id)){
        url += "&activity_id=" + activity_id;
    }
    
    return async (dispatch) => {
      dispatch(fetchAuditTrailRequest);
      try {
        const response = await api.get(url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
        const auditTrailList = response.data.data;
        dispatch(fetchAuditTrailSuccess(auditTrailList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchAuditTrailFailure(errorMsg));
      }
    };
  };
  